export default {
  
   
  Form: {
    "labelFontSize": 20,
    "labelHeight": 58 
},
  Input:{
    "controlHeight": 58,
    "paddingInline": 25,
    "fontSize": 16
  },
  "Button": {
    "controlHeight": 59,
    "colorLink": "#5165AF"
  },
  Select:{
      "controlHeight": 58,
  },
  "Switch": {
      "handleSize": 24,
      "trackHeight": 28,
      "fontSize": 20
    },
    "Alert": {
      "fontSize": 20
    },
  colorPrimary: "#212f93",
  colorLink:"#10319A",
  colorTextPlaceholder:"#A0A0A0"
}